import React, { useEffect, useState, useRef } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import { useSelector, useDispatch } from 'react-redux'
import { checkSbmit,generateDocSubmit,dmsIproposeSubmit,submitBPM, submitBPMFu } from '../../store/features/CameraAndSignatureSlice';
import { getOtpVerif, getOtpGenerate } from '../../store/features/OTPSlice'
import Spinners from '../../component/Spinner/spinners';
import cookie from 'js-cookie'
import { updateStatusSpaj, updateStatusCustomer } from '../../store/features/SPAJSlice';
import { Row, Col, Modal, Form } from 'react-bootstrap'
import OTPInput, { ResendOTP } from 'otp-input-react'
import OtpInput from 'react-otp-input';

import {getToday, getTime } from '../../component/Helper'
import './otpstyles.css'
import Api from '../../Config/Api'
import MasterApi from '../../Config/MasterApi'

const renderButton = buttonProps => {
  return (
    <>
      <div>
        <div className='fs-12'>Tidak menerima SMS?</div>
        <div className='mb-10'>
        <button
            className='button-otp'
            disabled={buttonProps.disabled}
            onClick={buttonProps.onClick}
          >
            Kirim Ulang Kode OTP
          </button>
        </div>
      </div>
    </>
  )
}

const rendertime = rendertime => {
  let detik = rendertime
  let minute = Math.floor(detik / 60)
  let second = detik % 60

  if (second < 10) {
    return (
      <div style={{display:"none"}}>
        {minute} : 0{second}
      </div>
    )
  } else {
    return (
      <div style={{display:"none"}}>
        {minute} : {second}{' '}
      </div>
    )
  }
}

const sendOtp = (data, OTPexp, setOTPexp, Parameter,OTPVal,setOTPVal,setMinutes,setSeconds) => {
  const userAgent =
    navigator.userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || []
  let dataGenerate = {
    deviceId: `${userAgent[1]}`,
    userName: `${data.spajHeader?.userName}`,
    sentVia: 'sms',
    moduleApp: 'login',
    spajNumber: `${data.spajHeader.spajNumber}`
  }

  let dataz = Parameter.dataParameterApps.find(url =>{
    if (url.codeSetting == "OTP_EXPIRED"){
        // setOTPexp(url.valueSetting)
        return url.valueSetting
    }
  })

  let detik = dataz.valueSetting % 60
  let menit =  Math.floor(dataz.valueSetting/60)
  setMinutes(menit)
  setSeconds(detik)

  Api.post(Api.routeHelper+MasterApi.otpGenerate, dataGenerate)
    .then(response => {
      const minute = Math.floor(dataz.valueSetting/60)
      const OTPVal = (Number(response.data.createDate.split("T")[1].split(".")[0].split(":")[1])+minute)
      setOTPVal(OTPVal)
      return response
    })
    .catch(err => {
      return err
    })
}
const Timer = (data) => {
  let seconds = data.seconds
  let setSeconds = data.setSeconds
  let setMinutes = data.setMinutes
  let minutes = data.minutes

  useEffect(()=>{
  let myInterval = setInterval(() => {
          if (seconds > 0) {
              setSeconds(seconds - 1);
          }
          if (seconds === 0) {
              if (minutes === 0) {
                  clearInterval(myInterval)
              } else {
                  setMinutes(minutes - 1);
                  setSeconds(59);
              }
          } 
      }, 1000)
      return ()=> {
          clearInterval(myInterval);
        };
  });

  return (
    <div style={{textAlign:"center"}}>
      { minutes === 0 && seconds === 0
          ? <div> 00:00</div> 
          : <div> {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}</div> 
      }
      </div>
  )
}


const ReturnData = ({
  setMinutes,
  minutes,
  setSeconds,
  seconds,
  setOTPVal,
  OTPVal,
  setOTPexp,
  OTPexp,
  Parameter,
  reSentChance,
  setreSentChance,
  setMaxChance,
  maxChance,
  spaj,
  setOTP
}) => {
  let string
  let string2

  Parameter.dataParameterApps.map(params => {
    if (params.codeSetting == 'OTP_FALSE') {
      setMaxChance(params.valueSetting)
      string = (
        <div className='kesempatan mt-1' key={params.id}>
          {reSentChance}/{params.valueSetting}
        </div>
      )
    } else if (params.codeSetting == 'OTP_WAITING') {
      string2 = (
        <>
          <Timer
            Parameter={Parameter}
            setSeconds={setSeconds}
            seconds={seconds}
            setMinutes={setMinutes}
            minutes={minutes}  
          />
          <div
          key={params.id}
          className='mt-3 d-flex justify-content-center container-otp'
          >
            {' '}
            <ResendOTP
              maxTime={params.valueSetting}
              // maxTime={3}
              className={'timer-otp'}
              renderButton={renderButton}
              renderTime={rendertime}
              onResendClick={() => {
                setreSentChance(0)
                sendOtp(spaj, OTPexp, setOTPexp, Parameter, OTPVal, setOTPVal,setMinutes, setSeconds)
                setOTP('')
                setSubmitClick(false)
              }}
            >
              {' '}
            </ResendOTP>{' '}
          </div>
        </>
      )
    }
  })

  if (reSentChance >= maxChance) {
    return [
      string,
      //FOR DEV
      //   <ReCAPTCHA
      //     key={'captcha'}
      //     className='g-recaptcha'
      //     sitekey='6Ldp_T0gAAAAAF0U-pYdZF2UgtY0oDjdgqpzy6Ov'
      //     onChange={() => setreSentChance(0)}
      //   />
        //FOR UAT PROD
          <ReCAPTCHA
            key={'captcha'}
            className='g-recaptcha'
            sitekey='6LdsYG8gAAAAAFL4MoWjadi3DVNfbMPnFDa5BYIo'
            onChange={() => {
              setreSentChance(0)
              sendOtp(spaj, OTPexp, setOTPexp, Parameter, OTPVal, setOTPVal,setMinutes, setSeconds  )
              setOTP('')
              setSubmitClick(false)
            }}
          />
    ]
  } else {
    return [string, string2]
  }
}

const OtpKonfirmasi = () => {
  let navigate = useNavigate()
  const { SPAJs } = useSelector((state) => state.SPAJs)
  const { SPAJDetail } = useSelector((state) => state.SPAJsDetail)
  const { DeviceId } = useSelector((state)=>state.DeviceId)
  let [errMsg, setErrMsg] = useState("")
  let [loading, setLoading] = useState(false)
  let [digitErrorOTP,setDigitErrorOTP] = useState(false)
  let [notMatchOTP,setNotMatchOTP] = useState(false)
  let [errOTPExp, setErrOTPExp] = useState(false)
  const [submitClick, setSubmitClick] = useState(false)
  const [OTP, setOTP] = useState('')
  const [OTPexp, setOTPexp] = useState(0)
  const [seconds, setSeconds] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [OTPVal, setOTPVal] = useState()
  const userAgent =
  navigator.userAgent.match(
    /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/
  ) || []
  const dispatch = useDispatch()
  const [maxChance, setMaxChance] = useState('3')
  const [reSentChance, setreSentChance] = useState(0)
  const { Parameter } = useSelector(state => state.Params)

  useEffect(() => {
    let dataGenerate = {
      deviceId: `${userAgent[1]}`,
      userName: `${SPAJs.spajHeader?.userName}`,
      sentVia: 'sms',
      moduleApp: 'submit',
      spajNumber: `${SPAJs.spajHeader.spajNumber}`
    }

    let datas = Parameter.dataParameterApps.find(url =>{
      if (url.codeSetting == "OTP_EXPIRED"){
          // setOTPexp(url.valueSetting)
          return url.valueSetting
      }
    })

    let detik = datas.valueSetting % 60
    let menit =  Math.floor(datas.valueSetting/60)
    setSeconds(detik)
    setMinutes(menit)
    // UNCOMMENT THIS FOR UAT/PROD
    dispatch(getOtpGenerate(dataGenerate)).then(res => {
      const minute = Math.floor(datas.valueSetting/60)
      const OTPVal = (Number(res.payload.data.createDate.split("T")[1].split(".")[0].split(":")[1])+minute)
      setOTPVal(OTPVal)
    }).catch(err => {
        return err
    });
  }, [])

  const handleOtpLogin = e => {
    setLoading(true)
    e.preventDefault()
    let dataLogin = {
      deviceId: `${userAgent[1]}`,
      deviceType: `${userAgent[1]}`,
      userName: `${SPAJs.spajHeader.userName}`,
      spajNumber: `${SPAJs.spajHeader.spajNumber}`,
      otp: OTP
    }

    if (dataLogin.otp.length != 6) {
      // alert('OTP harus di isi dengan 6 digit')
      setLoading(false)
      setDigitErrorOTP(true)
    } else if (!dataLogin.otp) {
      // alert('Pastikan otp sesuai dengan yang Anda dapatkan')
      setNotMatchOTP(true)
      setLoading(false)
    } else if (parseInt(getTime().split(':')[1]) > OTPVal){
      setErrOTPExp(true)
      // alert("OTP Expired")
    } else {
      dispatch(getOtpVerif(dataLogin)).then(res => {
        if (res.payload.status === 'ERROR') {
          let msg = res.payload.errMsg
          setErrMsg(msg)
          setNotMatchOTP(true)
          setLoading(false)
          setOTP('')
          setreSentChance(reSentChance + 1)
        } else {
          setSubmitClick(true)
          // cookie.set('accessToken', SameSite="None", res.payload.token, { expires: 1 })
          // cookie.set('refreshToken', SameSite="None", res.payload.RefreshToken, { expires: 1 })
          // localStorage.setItem("TOKEN", JSON.stringify(res.payload));
              if (SPAJs.spajHeader?.statusCustomer == 'PDC') {
                let dataSubmit = {
                  deviceId:`${DeviceId.deviceId}`,
                  agentCode:`${SPAJDetail.dataSpaj.agentCode}`,
                  illustrationNumber:`${SPAJDetail.dataSpaj.illustrationNumber}`,
                  leadNumber:`${SPAJDetail.dataSpaj.leadNumber}`,
                  spajNumber:`${SPAJDetail.dataSpaj.spajNumber}`,
                  userName:`${SPAJDetail.dataSpaj.email}`
                }
                dispatch(generateDocSubmit({...dataSubmit, formKonfirmasi: 'Y'}))
                .then(res=>{
                  if(res.payload.status == "OK"){
                  dispatch(dmsIproposeSubmit({...dataSubmit,typeProcess:'S'}))
                  .then(res => {
                    if(res.payload.status == "OK"){
                      dispatch(submitBPMFu(dataSubmit))
                      .then(res => {
                        if(res.payload.status == "OK" || res.payload.Status == "OK"){
                          let detailData = {
                            deviceId: `${DeviceId.deviceId}`,
                            userName: `${SPAJs.spajHeader?.userName}`,
                            spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
                            agentStatus: "IN",
                            customerStatus: "IN"
                        }
                        dispatch(updateStatusSpaj(detailData)).then(res => {
                            // UPDATE LOCAL STATUS CUSTOMER KE  INP
                            dispatch(updateStatusCustomer("IN"));
                        })
                            cookie.remove('accessToken');
                            cookie.remove('refreshToken');
                            localStorage.removeItem("SPAJ_HEADER");
                            localStorage.removeItem("TOKEN");
                            sessionStorage.removeItem('tokenPayment');
                            navigate("/" + localStorage.getItem("spajHash"));
                            setLoading(false)
                        }else{
                          alert(res.payload.errMsg)
                          setSubmitClick(false)
                          setLoading(false)
                        }
                      })
                      }else{
                        alert(res.payload.errMsg)
                        setSubmitClick(false)
                        setLoading(false)
                      }
                  })
                  }else{
                    alert(res.payload.errMsg)
                    setSubmitClick(false)
                    setLoading(false)
                  }
                })
              }else if (SPAJs.spajHeader?.statusCustomer == 'P')
              {
                let dataSubmit = {
                  deviceId:`${DeviceId.deviceId}`,
                  agentCode:`${SPAJDetail.dataSpaj.agentCode}`,
                  illustrationNumber:`${SPAJDetail.dataSpaj.illustrationNumber}`,
                  leadNumber:`${SPAJDetail.dataSpaj.leadNumber}`,
                  spajNumber:`${SPAJDetail.dataSpaj.spajNumber}`,
                  userName:`${SPAJDetail.dataSpaj.email}`}
                dispatch(generateDocSubmit(dataSubmit))
                .then(res=>{
                  if(res.payload.status == "OK"){
                  dispatch(dmsIproposeSubmit(dataSubmit))
                  .then(res => {
                    if(res.payload.status == "OK"){
                      dispatch(submitBPM(dataSubmit))
                      .then(res => {
                        if(res.payload.status == "OK" || res.payload.Status == "OK"){
                          let detailData = {
                            deviceId: `${DeviceId.deviceId}`,
                            userName: `${SPAJs.spajHeader?.userName}`,
                            spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
                            agentStatus: "IN",
                            customerStatus: "IN"
                        }
                        dispatch(updateStatusSpaj(detailData)).then(res => {
                            // UPDATE LOCAL STATUS CUSTOMER KE  INP
                            dispatch(updateStatusCustomer("IN"));
                        })
                            cookie.remove('accessToken');
                            cookie.remove('refreshToken');
                            localStorage.removeItem("SPAJ_HEADER");
                            localStorage.removeItem("TOKEN");
                            sessionStorage.removeItem('tokenPayment');
                            navigate("/" + localStorage.getItem("spajHash"));
                            setLoading(false)
                        }else{
                          alert(res.payload.errMsg)
                          setSubmitClick(false)
                          setLoading(false)
                        }
                      })
                      }else{
                        alert(res.payload.errMsg)
                        setSubmitClick(false)
                        setLoading(false)
                      }
                  })
                  }else{
                    alert(res.payload.errMsg)
                    setSubmitClick(false)
                    setLoading(false)
                  }
                })
              }
              else
              {
                cookie.remove('accessToken');
                cookie.remove('refreshToken');
                localStorage.removeItem("SPAJ_HEADER");
                localStorage.removeItem("TOKEN");
                sessionStorage.removeItem('tokenPayment');
                navigate("/" + localStorage.getItem("spajHash"));
                setLoading(false)
              }
          // navigate('/thankyou')
        }
      })
    }
  }

  const setPopupError = () =>{
    let errors = false
    setErrOTPExp(errors)
    setNotMatchOTP(errors)
    setDigitErrorOTP(errors)
  }

  return (
    <>
      {loading == true && <Spinners />}
      <div>
        <Row className='g-0 welcome-container'>
          <Col xs={12} sm={12} md={12} lg={6}>
            <div className='left-container position-relative'>
              <div className='icon-container'>
                <img
                 src='images/generali-white.png.png'
                 className='icon-gen size-logo'
                />
              </div>
              <div className='logo-posisi'>
                <img src="images/generali-white.png" className='size-logo' />
              </div>
              <div className='position-cardfooter-otp'>
                <div className='card-container-otp shadow-lg'>
                  <form onSubmit={e => handleOtpLogin(e)}>
                    <div className='bold fs-16 text-center'>
                      Masukkan Kode OTP
                    </div>
                    <div className='mt-OTPInput2 mt-2'>
                      <div className='fs-12 text-center'>
                        Silakan Masukkan kode OTP yang telah kami kirimkan ke
                        Nomor Handphone Anda di {SPAJs.spajHeader?.phoneNo}, dan email {SPAJs.spajHeader?.userEncrypt}
                      </div>
                    </div>
                    <div className='mt-2 d-flex justify-content-center'>
                    <OtpInput
                      value={OTP}
                      onChange={setOTP}
                      numInputs={6} // Number of OTP input boxes
                      inputType={'tel'}
                      inputStyle={{
                        width: '50%',
                        height: '50px',
                        margin: '5px',
                        fontSize: '18px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                      }}
                      renderInput={(props) => <input {...props} />}
                    />
                    </div>
                    <ReturnData
                      setMinutes={setMinutes}
                      minutes={minutes}
                      setSeconds={setSeconds}
                      seconds={seconds}
                      setOTPVal={setOTPVal}
                      OTPVal={OTPVal}
                      setOTPexp={setOTPexp}
                      OTPexp={OTPexp}
                      Parameter={Parameter}
                      reSentChance={reSentChance}
                      setreSentChance={setreSentChance}
                      setSubmitClick={setSubmitClick}
                      setMaxChance={setMaxChance}
                      maxChance={maxChance}
                      spaj={SPAJs}
                      setOTP={setOTP}
                    />
                    <div className='mt-2'>
                      <button
                        className={!submitClick ? 'button-red' : 'button-red-disabled'}
                        type='submit'
                        disabled={submitClick}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>

              </div>
              <div className='logo-link-otp'>
                <div className='link-items'>www.generali.co.id</div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <div className='logo-posisi-potrait'>
            <img src="images/header2.png" className='size-logo' />
            </div>
            <div>
              <img src='images/loginpage.jpg' className='ilustration imageOtp2' id='image-otp'/>
            </div>
          </Col>
        </Row>
      </div>

      <Modal dialogClassName='modalcustom' centered show={digitErrorOTP}>
          <Modal.Body style={{margin: 25}}>
              <div className='d-flex flex-column justify-content-center align-items-center'>
                  <p className='fs-15 text-center'>OTP harus di isi dengan 6 digit</p>
                      <div onClick={() => setPopupError()}>
                          <div className='buttonkembalimodal'>
                              <button>OK</button>
                          </div>
                      </div>
              </div>
          </Modal.Body>
      </Modal>
      <Modal dialogClassName='modalcustom' centered show={notMatchOTP}>
          <Modal.Body style={{margin: 25}}>
              <div className='d-flex flex-column justify-content-center align-items-center'>
                  <p className='fs-15 text-center'>{errMsg}</p>
                      <div onClick={() => setPopupError()}>
                          <div className='buttonkembalimodal'>
                              <button>OK</button>
                          </div>
                      </div>
              </div>
          </Modal.Body>
      </Modal>
      <Modal dialogClassName='modalcustom' centered show={errOTPExp}>
          <Modal.Body style={{margin: 25}}>
              <div className='d-flex flex-column justify-content-center align-items-center'>
                  <p className='fs-15 text-center'>OTP Expired</p>
                      <div onClick={() => setPopupError()}>
                          <div className='buttonkembalimodal'>
                              <button>OK</button>
                          </div>
                      </div>
              </div>
          </Modal.Body>
      </Modal>

    </>
  )
}

export default OtpKonfirmasi